<template>
	<div class="hidden grow basis-1/2 pr-20 lg:block">
		<span class="text-main-400 block lg:mb-4 lg:text-2xl">{{ text || 'Helpful tips' }}</span>

		<p
			class="text-primary text-left text-xl"
			:class="{
				'line-clamp-3 after:relative after:block after:shadow-[0_0_15px_20px_white]':
					collapsed,
			}"
		>
			<slot />
		</p>

		<ChevronDownSvg
			v-if="false"
			class="fill-success-base m-auto box-content h-9 w-9 cursor-pointer p-5 pt-1"
			:class="{ 'rotate-180 pb-1 !pt-5': !collapsed }"
			@click="collapsed = !collapsed"
		/>
	</div>
</template>

<script lang="ts" setup>
	import ChevronDownSvg from './icons/ChevronDownSvg.vue'
	import { ref } from 'vue'

	defineProps<{ text?: string }>()
	const collapsed = ref(false)
</script>
